import yup from "src/utils/yup/extensionMethods";

const deleteSchema = (translate: Function) => yup.object().shape({
	ara001Assunto: yup.string()
		.required(translate("Assunto da reunião não confere"))
		.oneOf([yup.ref("ara001AssuntoConfirmation")], translate("Assunto da reunião não confere"))
});

export const FormSchema = (translate: Function) => yup.object().shape({
	ara001Assunto: yup.string()
		.required(translate("Assunto da reunião é requerido")).max(200, translate("Assunto deve conter no máximo 200 caracteres")),
	ara001Dthrinicio:yup.date()
		.required(translate("Data e hora inicial é requerida")),
	ara001Dthrfim:yup.date()
		.required(translate("Data e hora final é requerida"))
		.min(
			yup.ref("ara001Dthrinicio"),
			translate("Data Final tem que ser após a Data Inicial")
		),
	ara001Efa005Id: yup.string()
		.required(translate("Responsável é requerido")),
	ara001Taa008Id: yup.string()
		.required(translate("Sala de reunião é requerido")),
	ara001Pauta: yup.string()
		.transform((value,originalValue) => originalValue && originalValue !== "<p></p>\n" ? value : "")
		.required(translate("Pauta é requerida")),
	participants: yup.array().of(artba002Schema(translate))
		.unique(translate("Participantes não podem ser repetidos"), (a: any) => a.ara002Efa005Id, (a: any) => a.typeParticipant === "user")
		.unique(translate("Participantes externos não podem ser repetidos"), (a: any) => a.ara002Participante, (a: any) => a.typeParticipant === "person")
});

const artba002Schema = (translate: Function) => yup.object().shape({
	ara002Efa005Id: yup.string()
		.transform((value,originalValue) => originalValue ? value : "")
		.when("ara002Participante",(person,schema) => !person ? schema.required(translate("Participante é requerido")):schema.nullable()),
	ara002Participante: yup.string()
		.transform((value,originalValue) => originalValue ? value : "")
		.when("ara002Efa005Id",(user,schema) => !user ? schema.required(translate("Participante externo é requerido")):schema.nullable())
},[["ara002Efa005Id","ara002Participante"]]);

export default deleteSchema;
